import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { DzFontFaceService } from '@blk/daisy/core/font-face';
import { ReportData, ReportGenerationService } from '@ddt-web/common';
import { UrlRedirectService } from '@ddt-web/url';
import { first } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'pdf-previewer',
	templateUrl: './pdf-previewer.component.html',
	styleUrls: ['./pdf-previewer.component.scss']
})
export class PdfPreviewerComponent implements AfterViewInit {
	@Input() public pages: Array<string> = [];
	@Input() public landscape: boolean = false;
	@Input() public applicationName: string;
	@Input() public exportAsPNG: boolean;

	@Output() public isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public readonly REPORT_CONTAINER: string = 'report-container';
	public dimension: string = '300px';

	constructor(
		public contentService: ContentService,
		private reportSvc: ReportGenerationService,
		private urlRedirectService: UrlRedirectService,
		private dzFontFaceService: DzFontFaceService
	) { }

	public ngAfterViewInit(): void {
		const container = document.getElementById(this.REPORT_CONTAINER);
		container.style.width = this.landscape ? '850px' : '800px';
		container.style.height = '850px';

		if (container) {
			(<HTMLFrameElement>container).contentDocument.body.innerHTML = '';
			const iframeDoc = (<HTMLFrameElement>container).contentDocument;
			const style = iframeDoc.createElement('style');
			iframeDoc.head.appendChild(style);
			style.innerHTML = `
				body {
					background-color : grey;
					text-align : center;
				}

				svg {
					background-color : white;
					margin: 10px;
				}

			`;
			this.dzFontFaceService.loadFonts(iframeDoc);

			if ((<HTMLFrameElement>container).contentDocument.body.innerHTML !== '') {
				return;
			}
			this.pages.forEach((templateMarkup: string) => {
				const svgDoc: Document = new DOMParser().parseFromString(templateMarkup, 'text/html');
				for (let i = 0; i < svgDoc.body.childNodes.length; i++) {
					(<HTMLFrameElement>container).contentDocument.body.appendChild(svgDoc.body.childNodes[i]);
				}
			});
		}
	}

	public onClose(visible: boolean): void {
		this.isVisibleChange.emit(visible);
	}

	public generate(): void {
		const report = new ReportData();
		report.fileName = this.exportAsPNG ? 'preview.zip' : 'preview.pdf';
		report.svgPages = this.pages;
		this.reportSvc.generateReport(report, this.landscape, this.exportAsPNG)
			.pipe(first())
			.subscribe(done => {
				if (done) {
					this.urlRedirectService.redirectToMainPage(this.applicationName);
				}
			});
	}
}
